module.exports = __webpack_public_path__ + "4fd7031d73022c76d48da3037455fa36.pdf";